module.exports = __webpack_public_path__ + "img/855-b48af0.png";